<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
    :hasSelectContentBg="true"
    class="cart-list-wrap"
  >
    <template slot="select-content-bg">
      <div class="select-content-bg"></div>
    </template>
    <template slot="select-header">
      <div class="cart-detail-close j-click-close-cart" @click="close"></div>
    </template>
    <template slot="select-content">
      <div class="product-wrap">
        <div
          v-for="item in cartList"
          class="product-box"
          :key="item.PRODUCT_ID + item.CP_PRODUCT_ID"
        >
          <div class="product-item">
            <div class="tag-wrap">
              <span class="product-tag" v-if="extraTip(item)">
                {{ extraTip(item) }}
              </span>
              <span class="product-tag coupon" v-if="+item.COUPON">{{
                letter.couponCanUseQuan
              }}</span>
              <span
                class="product-tag"
                v-if="[211, 209].includes(+gameId) && item.PRODUCT_TAG"
                >{{ item.PRODUCT_TAG }}</span
              >
            </div>
            <div class="detail-wrap">
              <div class="left">
                <div class="text">
                  <p class="product-name name">
                    {{ getProductName(item) }}
                  </p>
                </div>
                <prop-img :item="item"></prop-img>
              </div>
              <div class="right">
                <div
                  class="product-price"
                  v-if="
                    item.amountLevel &&
                    item.amountLevel.TRANS_AMOUNT &&
                    item.amountLevel.SHOW_CURRENCY
                  "
                >
                  {{ item.amountLevel.TRANS_AMOUNT
                  }}{{ item.amountLevel.SHOW_CURRENCY }}
                </div>
                <div class="quantity">
                  <span
                    class="quantity-item action j-click-sub-to-cart-cart-list"
                    @click="subProduct(item)"
                    >-</span
                  >
                  <span class="quantity-item total">{{ item.quantity }}</span>
                  <span
                    class="quantity-item action j-click-add-to-cart-cart-list"
                    @click="addToCart($event, item, '', false)"
                    >+</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialStore/selectContainer';
import {
  SUB_PRODUCT_OF_CART,
  UPDATE_SHOW_CART_DELETE_POPUP,
  UPDATE_DELETE_ITEM
} from '@store/officialStore/cart';
import cartAddAndDetail from '@mixins/officialStore/cartAddAndDetail';
import { commonEmitUpload } from '../../../plugins/AnalyzePoint/index';
import PropImg from '@components/officialStore/product/PropImg.vue';
import { mapState } from 'vuex';
import product from '@mixins/officialStore/product';
import { popupType, showPopup } from '@plugins/biPoint/_configWebstoreV1';
import productName from '@mixins/product';
export default {
  mixins: [selectContainer, cartAddAndDetail, product, productName],
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      cartList: state => state.cart.cartList
    })
  },
  methods: {
    subProduct(item) {
      if (+item.quantity === 1) {
        commonEmitUpload('click-delete-to-cart-cart-list', {
          event: 'click-delete-to-cart-cart-list',
          newPage: false,
          type: 'click'
        });
        this.$store.commit(UPDATE_DELETE_ITEM, item);
        this.$store.commit(UPDATE_SHOW_CART_DELETE_POPUP, true);
        showPopup(popupType.removeCartProductPopup);
        return;
      }
      this.$store.commit(SUB_PRODUCT_OF_CART, item);
    }
  },
  components: {
    PropImg
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.cart-list-wrap {
  z-index: 19 !important;
}
.cart-detail-close {
  background-size: cover;
  @psetbg ('cart-list-fold-ico.png');
}
::v-deep .select-header {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  padding: 0 26px;
  height: 89px;
}
::v-deep .select-content {
  position: relative;
  padding: 0 26px 260px;
  .product-wrap {
    box-sizing: border-box;
  }
}
.select-content-bg {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  @psetbg ('cart-list-bg.png', false, false);
}
.product-box {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  padding: 0;
}
.product-item {
  display: flex;
  overflow: hidden;
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
  margin-bottom: 19px;
  padding: 15px 12px 22px;
  background-size: 100% 100%;
  cursor: pointer;
  @psetbg ('cart-list-item-bg.png', false, false);
  .tag-wrap {
    border-bottom: 2px solid var(--product-item-fenge-line);
    height: 41px;
    .product-tag {
      margin-right: 16px;
      padding: 5px 15px;
      border: 1px solid var(--product-item-tag-border);
      background: var(--product-item-tag-bg);
      font-size: 20px;
      color: var(--product-item-tag-text);
      &.coupon {
        background-color: var(--product-item-tag-coupon-bg);
      }
    }
  }
  .detail-wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 20px;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 445px;
      .img-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 18px;
        width: 100px;
        height: 100px;
        background: url($pnsImg + 'product.png') no-repeat top;
        background-size: cover;
        .product-icon {
          width: 80%;
          height: auto;
        }
      }
      .text {
        display: flex;
        margin-bottom: 50px;
        width: 100%;
        .product-name {
          line-height: 32px;
          /*!rtl:ignore*/
          direction: ltr;
          font-size: 24px;
          color: var(--product-item-name);
        }
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: 170px;
      .product-price {
        margin-bottom: 38px;
        text-align: center;
        font-size: 36px;
        color: var(--product-item-price);
      }
      .quantity {
        border: 1px solid #333;
        width: 201px;
        height: 51px;
        background-color: var(--cart-list-sub-bg);
        font-size: 36px;
        color: #333;
        &-item {
          display: inline-block;
          height: 100%;
          line-height: 50px;
          text-align: center;
        }
        .total {
          border-left: 1px solid #333;
          border-right: 1px solid #333;
          width: 98px;
        }
        .action {
          width: 50px;
        }
      }
    }
  }
}
@media screen and (orientation: landscape) {
  ::v-deep .select-content {
    padding: 0 250px 260px;
  }
  ::v-deep .product-detail {
    width: 446px;
  }
}
</style>
